import * as yup from 'yup'

export default function cguSchema() {
  return yup.boolean().required('Vous devez accepter les CGU').oneOf([true], 'Vous devez accepter les CGU')
}
